module.exports = __webpack_public_path__ + "img/avatar7.ad323d5c.png";